export const ONE_SIGNAL = {
  TAGS: {
    EXTERNAL_ID: 'external-id',
  },
};
